import {
  NumberColValue,
  ResponsiveOffsetValue,
  OffsetValue,
} from '../GridV2/types';

export const DIALOG_SHEET_COL_PROPS: {
  s: {
    xs: NumberColValue;
    sm: NumberColValue;
    lg: NumberColValue;
    offset: ResponsiveOffsetValue;
  };
  m: {
    xs: NumberColValue;
    sm: NumberColValue;
    md: NumberColValue;
    offset: ResponsiveOffsetValue;
  };
  l: {
    xs: NumberColValue;
    sm: NumberColValue;
    offset: ResponsiveOffsetValue;
  };
  full: {
    xs: NumberColValue;
  };
} = {
  s: {
    xs: 12,
    sm: 8,
    lg: 6,
    offset: { sm: 2, lg: 3 },
  },
  m: {
    xs: 12,
    sm: 10,
    md: 8,
    offset: { sm: 1, md: 2 },
  },
  l: {
    xs: 12,
    sm: 10,
    offset: { sm: 1 },
  },
  full: {
    xs: 12,
  },
};

export const DIALOG_CONTENT_COL_PROPS: {
  s: {
    xs: NumberColValue;
    sm: NumberColValue;
    md: NumberColValue;
    lg: NumberColValue;
    offset: OffsetValue;
  };
  m: {
    xs: NumberColValue;
    sm: NumberColValue;
    md: NumberColValue;
    lg: NumberColValue;
    offset: ResponsiveOffsetValue;
  };
  'm-form': {
    xs: NumberColValue;
    sm: NumberColValue;
    md: NumberColValue;
    lg: NumberColValue;
    offset: ResponsiveOffsetValue;
  };
  full: {
    xs: NumberColValue;
    sm: NumberColValue;
    md: NumberColValue;
    lg: NumberColValue;
    offset: ResponsiveOffsetValue;
  };
} = {
  s: {
    xs: (DIALOG_SHEET_COL_PROPS.s.xs - 2) as NumberColValue,
    sm: (DIALOG_SHEET_COL_PROPS.s.sm - 2) as NumberColValue,
    md: (DIALOG_SHEET_COL_PROPS.s.sm - 2) as NumberColValue,
    lg: (DIALOG_SHEET_COL_PROPS.s.lg - 2) as NumberColValue,
    offset: 1,
  },
  m: {
    xs: DIALOG_SHEET_COL_PROPS.m.xs,
    sm: (DIALOG_SHEET_COL_PROPS.m.sm - 2) as NumberColValue,
    md: (DIALOG_SHEET_COL_PROPS.m.md - 2) as NumberColValue,
    lg: (DIALOG_SHEET_COL_PROPS.m.md - 2) as NumberColValue,
    offset: { sm: 1 },
  },
  'm-form': {
    xs: DIALOG_SHEET_COL_PROPS.m.xs,
    sm: (DIALOG_SHEET_COL_PROPS.m.sm - 4) as NumberColValue,
    md: (DIALOG_SHEET_COL_PROPS.m.md - 4) as NumberColValue,
    lg: (DIALOG_SHEET_COL_PROPS.m.md - 4) as NumberColValue,
    offset: { sm: 2 },
  },
  full: {
    xs: DIALOG_SHEET_COL_PROPS.full.xs,
    sm: (DIALOG_SHEET_COL_PROPS.full.xs - 4) as NumberColValue,
    md: (DIALOG_SHEET_COL_PROPS.full.xs - 6) as NumberColValue,
    lg: (DIALOG_SHEET_COL_PROPS.full.xs - 6) as NumberColValue,
    offset: { sm: 2, md: 3 },
  },
};
